import { mediaQuery, pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

import { dggTheme } from 'src/styles/dggTheme';
import { breakpoint } from 'src/styles/dontgiftguide.styles';

const { spacing } = dggTheme;

export const singleSnowflakeURL =
  'https://images.contentstack.io/v3/assets/blt83ec2ae5e0dbde7f/blt3f6424008a571182/single-snowflake-light.png';

export const singleSnowflakeDarkURL =
  'https://images.contentstack.io/v3/assets/blt83ec2ae5e0dbde7f/blt820dc1ad29c4b82a/single-snowflake-dark.png';

export const snowflake = css`
  position: absolute;
  right: 0;
  top: 0;
  transform: translate(15%, -35%);
  width: 70px;
  height: 70px;

  ${mediaQuery(
    { min: breakpoint },
    css`
      width: 150px;
      height: 150px;
      transform: translate(48%, -35%);
    `,
  )}
`;

export const partnerSection = css`
  position: relative;
  width: 350px;
  border-radius: 30px;
  margin: 0 auto ${pxToRem(spacing.xl)};

  ${mediaQuery(
    { min: breakpoint },
    css`
      margin-bottom: ${pxToRem(spacing.xxxxl)};
      width: 614px;
    `,
  )}

  img {
    object-fit: cover;
  }

  a {
    display: block;
  }
`;

export const productImage = css`
  z-index: 1;
  height: 350px;
  width: 350px;
  border-radius: 30px 30px 0 0;

  ${mediaQuery(
    { min: breakpoint },
    css`
      height: 614px;
      width: 614px;
    `,
  )}
`;

export const partnerImage = css`
  position: absolute;
  top: 300px;
  left: 125px;
  z-index: 2;
  width: 100px;
  height: 100px;

  ${mediaQuery(
    { min: breakpoint },
    css`
      top: 500px;
      left: 210px;
      width: 200px;
      height: 200px;
    `,
  )}
`;

export const link = css`
  text-decoration: none;
  color: inherit;
`;

export const description = css`
  padding: ${pxToRem(spacing.lg)};
  margin-top: ${pxToRem(spacing.xl)};

  ${mediaQuery(
    { min: breakpoint },
    css`
      margin-top: ${pxToRem(spacing.xxxxl)};
    `,
  )}
`;

export const copy = css`
  margin-bottom: ${pxToRem(24)};
  font-size: ${pxToRem(18)};
  line-height: ${pxToRem(22)};

  ${mediaQuery(
    { min: breakpoint },
    css`
      font-size: ${pxToRem(24)};
      line-height: ${pxToRem(28)};
    `,
  )}
`;

export const productLabel = css`
  font-size: ${pxToRem(14)};
  line-height: normal;

  ${mediaQuery(
    { min: breakpoint },
    css`
      font-size: ${pxToRem(24)};
    `,
  )}
`;
